"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubScpiRecourtCreditTrads = void 0;
exports.ESubScpiRecourtCreditTrads = {
    neSaisPas: "Je ne sais pas",
    non: "Non",
    oui: "Oui",
};
